// CALLED BY used by: /Assets/js/initialize-site.js
export default class TableHorizontalScroller {
    constructor() {
        // Otherwise always run on table.table
        this.tables = document.querySelectorAll("main table.table");
    }

    init() {
        // Modifies Table Element: Parents, Wrappers, and Siblings
        this.tableModifier(); // this always needs to run first as it adds left and right btns
    }

    // BEGIN HTML Element Modifiers

    // Check if Parent table-responsive (.table-responsive is a Bootstrap class) parent exists. If no parent create it
    tableResponsiveParent(table) {
        let parentDiv = table.closest("div.table-responsive");

        if (!parentDiv) {
            // Create a new div with the class "table-responsive"
            parentDiv = document.createElement("div");
            parentDiv.className = "table-responsive";

            // Insert the new div before the table
            table.parentNode.insertBefore(parentDiv, table);

            // Move the table inside the new div
            parentDiv.appendChild(table);
        }

        // Add the class "table-container" to the parent div
        parentDiv.classList.add("table-container");

    }

    // Check if table-wrapper parent exists. If no create parent. We attach the scroll buttons to this parent.
    tableWrapper(table) {
        let wrapper = table.closest("div.table-action-wrapper");

        // Check if the table is already inside a wrapper
        if (!wrapper) {
            // Create the new wrapper div
            wrapper = document.createElement("div");
            wrapper.className = "table-action-wrapper";

            // Insert the wrapper before the table
            table.before(wrapper);

            // Move the table inside the wrapper
            wrapper.appendChild(table);
        }

    }

    // END HTML Element Modifiers

    // Modify Table
    tableModifier() {
        let self = this;
        this.tables.forEach(function (table) {
            self.tableResponsiveParent(table);

            let parentResponsiveDiv = table.closest("div.table-responsive");

            self.tableWrapper(parentResponsiveDiv);
        });

    }
}
